import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

// export const getTales = async (uploadType = '') => {
//   const params = uploadType ? `?uploadType=${uploadType}` : '';
//   const response = await apiService.get(`${apiRoutes.tales}${params}`);
//   return response.data;
// };

export const getTales = async (payload) => {
  const response = await apiService.post(apiRoutes.tales, payload);
  return response.data;
};

export const updateTaleStatus = async (data) => {
  const response = await apiService.post(apiRoutes.taleStatus, data);
  return response.data;
};

export const destroyTale = async (data) => {
  const response = await apiService.post(apiRoutes.taleDestroy, data);
  return response.data;
};

export const getAIGeneratedStories = async () => {
  const response = await apiService.get(apiRoutes.adminAIGeneratedStories);
  return response.data;
};

export const destroyAITale = async (data) => {
  const response = await apiService.post(apiRoutes.aiTaleDestroy, data);
  return response.data;
};

export const getTaleDetail = async (data) => {
  const response = await apiService.post(apiRoutes.taleDetail, data);
  console.log('==77777777===response',response)
  return response.data;
};

export const getCharactersList = async () => {
  const response = await apiService.get(apiRoutes.adminCharactersList);
  return response.data;
};


export const updateCharacterStatus = async (data) => {
  const response = await apiService.post(apiRoutes.updateCharacterStatus, data);
  return response.data;
};


export const destroyCharacter = async (data) => {
  const response = await apiService.post(apiRoutes.characterDestroy, data);
  return response.data;
};

export const getCharacterDetail = async (data) => {
  const response = await apiService.post(apiRoutes.adminCharacterDetail, data);
  return response.data;
};

export const getMostPopularTales = async () => {
  const response = await apiService.get(apiRoutes.adminMostPopularTales);
  return response.data;
};

export const userTaleListByType = async (payload) => {
  const response = await apiService.post(apiRoutes.userTaleListByType, payload);
  return response.data;
};

export const userCharacterList = async (payload) => {
  const response = await apiService.post(apiRoutes.userCharacterList, payload);
  return response.data;
};

